/**
 * class 数据控制集
 *
 * 载、十载、百载、千载
 极、十极、百极、千极
 恒河沙、十恒河沙、百恒河沙、千恒河沙
 阿僧祗、十阿僧祗、百阿僧祗、千阿僧祗
 那由他、十那由他、百那由他、千那由他
 不可思议、十不可思议、百不可思议、千不可思议
 无量、十无量、百无量、千无量
 大数、十大数、百大数、千大数
 * */
import gameConfig from "../configs/gameConfig";

const NUMBER_FORMATS = [
    {numValue: 1e4, text: '万'},
    {numValue: 1e8, text: '亿'},
    {numValue: 1e12, text: '兆'},
    {numValue: 1e16, text: '蛇'},
    {numValue: 1e20, text: '马'},
    {numValue: 1e24, text: '羊'},
    {numValue: 1e28, text: '猴'},
    {numValue: 1e32, text: '鸡'},
    {numValue: 1e36, text: '狗'},
    {numValue: 1e40, text: '猪'},
    {numValue: 1e44, text: '鼠'},
    {numValue: 1e48, text: '牛'},
    {numValue: 1e52, text: '虎'},
    {numValue: 1e56, text: '兔'},
    {numValue: 1e60, text: '龙'},
    {numValue: 1e64, text: '玄武'},
    {numValue: 1e68, text: '朱雀'},
    {numValue: 1e72, text: '白虎'},
    {numValue: 1e76, text: '青龙'},
    {numValue: 1e80, text: '太阴'},
    {numValue: 1e84, text: '太阳'},
    {numValue: 1e88, text: '饕餮'},
    {numValue: 1e92, text: '混沌'},
    {numValue: 1e96, text: '穷奇'},
    {numValue: 1e100, text: '梼杌'},
    {numValue: 1e104, text: 'tt'},
    {numValue: 1e108, text: 'uu'},
    {numValue: 1e112, text: 'vv'}
];

export interface CloseAStarPotMap {
    [ij: string]: boolean;
}

export class AStarPot {
    i: number;
    j: number;
    parent: AStarPot;
    parentCount: number;

    constructor(i: number, j: number, parent: AStarPot) {
        this.i = i;
        this.j = j;
        this.parent = parent;
        this.parentCount = 0;
        if (parent) {
            this.parentCount = parent.parentCount + 1;
        }
    }

    equals(other: AStarPot): boolean {
        return other.i == this.i && other.j == this.j;
    }

    inList(list: AStarPot[]): boolean {
        for (let p of list) {
            if (this.equals(p)) {
                return true;
            }
        }
        return false;
    }
}

/*
* 载、十载、百载、千载
极、十极、百极、千极
恒河沙、十恒河沙、百恒河沙、千恒河沙
阿僧祗、十阿僧祗、百阿僧祗、千阿僧祗
那由他、十那由他、百那由他、千那由他
不可思议、十不可思议、百不可思议、千不可思议
无量、十无量、百无量、千无量
大数、十大数、百大数、千大数*/

export default class data_control {
    private static readonly IDs = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';

    /**
     * @param Len 长度
     * @return ID
     */
    static getRandId(Len: number = 16): string {
        let id = '';
        for (let i = 0; i < Len; i++) {
            let ip = Math.floor(Math.random() * this.IDs.length);
            id += this.IDs[ip];
        }
        return id;
    }

    /**
     * 使值取区间内
     * @param value 源值
     * @param minValue 最小值
     * @param maxValue 最大值
     * */
    static getValueOfAreaMinMax(value: number, minValue: number, maxValue: number): number {
        if (value < minValue) return minValue;
        if (value > maxValue) return maxValue;
        return value;
    }

    /**
     * 使值循环于区间内
     * @param value 源值
     * @param minValue 最小值
     * @param maxValue 最大值
     * */
    static getNumLoopOfAreaMinMax(value: number, minValue: number, maxValue: number): number {
        if (value < minValue) return maxValue;
        if (value > maxValue) return minValue;
        return value;
    }

    /**
     * 求和
     * */
    static sum(array: number[]) {
        let sumValue = 0;
        for (let num of array) {
            sumValue += num;
        }
        return sumValue;
    }

    /**
     * 从数组里随机取一个成员返回
     * @param ary 源数组
     * */
    static getRandItemOfArray<T>(ary: T[]): T {
        let i = Math.floor(Math.random() * ary.length);
        return ary[i];
    }
    
    /**
     * 从数组里随机取一个成员返回
     * @param ary 源数组
     * */
    static getRandArrItem<T>(ary: T[]): T {
        let idx = this.randomNumInt(0, ary.length-1);
        return ary[idx];
    }

    /**
     * 从区间里取值 [最小值,最大值]
     * */
    static getRandNumberOfArrayTwo(array: number[]) {
        if (array.length != 2 || array[0] > array[1]) {
            console.error('#40 data_control 错误的区间', array);
            return NaN;
        }
        return array[0] + Math.random() * (array[1] - array[0]);
    }

    /**
     * 通过一组权重获取数组获取随机下标
     * @param weights 权重数组
     */
    public static getRandIPosByWeights(weights: number[]): number {
        //
        const weightSum = this.sum(weights);
        let randSum = Math.random() * weightSum;
        //
        for (let i = 0; i < weights.length; i++) {
            randSum -= weights[i];
            if (randSum <= 0) {
                return i;
            }
        }
        console.error('#114 data_control 不可能的错误', weights);
        return NaN;
    }

    /**
     * 获得随机数（包含小数部分）
     * @param minNum 
     * @param maxNum 
     * @returns 
     */
    static randomNum(minNum: number, maxNum: number): number {
        switch (arguments.length) {
            case 1:
                return Math.random() * minNum + 1;
            case 2:
                return Math.random() * (maxNum - minNum) + minNum;
            default:
                return 0;
        }
    }
    
     /**
     * 获得随机数，只取整数部分
     * @param minNum 
     * @param maxNum 
     * @returns 
     */
     static randomNumInt(minNum: number, maxNum: number): number {
        let num = this.randomNum(minNum, maxNum);
        return Math.round(num);
    }

    /**
     * 随机获得多个随机数
     * @param minNum 
     * @param maxNum 
     * @param count 
     * @returns 
     */
    static randomIntNum(minNum: number, maxNum: number, count: number) {
        let space = maxNum - minNum+1;
        if (count > space) {
            count = space;
        }
        let retNum: number[] = [];
        while(count > 0) {
            let num = this.randomNumInt(minNum, maxNum);
            if (retNum.indexOf(num) == -1) {
                retNum.push(num);
                count--;
            }
        }
        return retNum;
    }

    /**
     * 是否同一天
     * @param nowTime 
     * @param oldTime 
     * @returns 
     */
    static isNextDay(nowTime: number, oldTime: number) {
        let nowDate: Date = new Date();
        nowDate.setTime(nowTime);
        let oldDate: Date = new Date();
        oldDate.setTime(oldTime);

        var nowYear = nowDate.getFullYear();
        var nowMonth = nowDate.getMonth()+1;
        var nowDay = nowDate.getDate();

        var oldYear = oldDate.getFullYear();
        var oldMonth = oldDate.getMonth()+1;
        var oldDay = oldDate.getDate();

        var isNextDay = false;
        if (nowYear > oldYear) {
            isNextDay = true;
        } else {
            if (nowMonth > oldMonth) {
                isNextDay = true;
            } else {
                if (nowDay > oldDay) {
                    isNextDay = true;
                }
            }
        }

        return isNextDay;
    }

    /**
     * 获取下一天凌晨的时间
     * @param nowTime 
     * @returns 
     */
    static getOtherDayStartTime(
        nowTime: number
        , bNext: boolean = true
    ) {
        let nowDate: Date = new Date();
        nowDate.setTime(nowTime);
        if (bNext) {
            nowDate.setHours(24,0,0,0);
        } else {
            nowDate.setHours(0,0,0,0);
        }
        return nowDate.valueOf();
    }

    /**
    * 判断是否命中概率, 概率为小数
    * @param proNum 
    * @returns 
    */
    static isHitProbability (proNum) {
        if (proNum == '' || proNum == null || proNum == undefined) return false;
        if (Number(proNum) <= 0) {
            return false;
        }
        let probability = Number(proNum) * 100;
        let randomNum = Math.floor(this.randomNum(1, 10000)) / 100;
        return randomNum <= probability;
    }

    /**
     * 对数组进行乱序操作
     * @param array 源数组
     */
    static randomSortArray<T>(array: T[]): T[] {
        array.sort((a, b) => {
            return Math.random() - 0.5;
        })
        return array;
    }

    /**
     * @param {Number} num
     * @return {String} 单位格式
     * */
    static getNumberFormat(num: number, fixedLen = 2): string {
        //常量里是从小到大的，所以要反序
        let symbol:string = "";
        if(num < 0){
            symbol = "-";
        }
        num = Math.abs(num);
        let fixedNum = Math.pow(10, fixedLen);
        const ary = NUMBER_FORMATS;
        for (let i = ary.length - 1; i >= 0; i--) {
            const {numValue, text} = ary[i];
            if (num >= numValue) {
                // let rG = (num / numValue).toFixed(fixedLen);
                let rG = Math.floor(num / numValue * fixedNum) / fixedNum;
                return symbol + `${rG}${text}`;
            }
        }
        let rg = Math.floor(num * fixedNum) / fixedNum;
        // let rg = Number(Number(num).toFixed(fixedLen));
        return '' + symbol + rg;
    }

    static getNumberSplitCharString(num: number, char: string = ','): string {
        let n = String(Math.floor(num));
        n = n.replace(/(?=(?!\b)(?:\d{3})+(?!\d))/g, char);
        return n;
    }

    /**
     * 返回一个保留指定位数小数的字符串
     * @param srcNumber 源数值
     * @param tail 保留的位数，默认两位
     * @param isClearLastZero 是否去除小数点后末尾多余的零 默认否
     * @return 最终数值字符表现
     */
    static keepDecimals(srcNumber: number, tail: number = 2, isClearLastZero = false): string {
        let res = srcNumber.toFixed(tail);
        if (isClearLastZero) {
            return '' + Number(res);
        }
        return res;
    }

    /**
     * 将数字转大写
     * */
    static getChineseNum(str: string | number) {
        str = String(str);
        if (!/^([1-9]\d*)/.test(str)) {
            return '非法数据';
        }
        let unit = '千百十亿千百十万千百十个';
        if (str.length > unit.length) {
            return '数据过长';
        }
        let newStr = '';
        let nLength = str.length;
        unit = unit.substr(unit.length - nLength);
        for (let i = 0; i < nLength; i++) {
            newStr += '零一二三四五六七八九'.charAt(Number(str[i])) + unit.charAt(i);
        }
        console.log(newStr);
        newStr = newStr.substr(0, newStr.length - 1);
        console.log(newStr);
        newStr = newStr.replace(/零(千|百|十)/g, '零').replace(/(零)+/g, '零').replace(/零(亿|万)/g, '$1');
        return newStr;
    }


    /**
     * @param timeNum 秒
     * return 返回 hh:mm:ss 格式 如 3600秒返回 01:00:00
     * */
    static getTimeFormatClock(timeNum: number): string {
        const m = 60 * 1;
        const t = 60 * m;
        let str = '';
        //时
        let strT = Math.floor(timeNum / t);
        if (strT > 0) {
            str += `${String(strT).padStart(2, '0')}:`;
        }
        //分
        let strM = Math.floor(timeNum % t / m);
        str += `${String(strM).padStart(2, '0')}:`;
        //秒
        str += String(timeNum % m).padStart(2, '0');
        return str;

    }

    /**
     * 获取当天的日期格式
     * */
    static getCurrDateDayString(): string {
        const d = new Date();
        let str = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
        return str;
    }

    public static GetWorldPos(localPos:cc.Node):cc.Vec2{
        let res = localPos.parent.convertToWorldSpaceAR(localPos.getPosition());
        res.addSelf(cc.v2(cc.winSize.width*-0.5,cc.winSize.height*-0.5));

        return res;
    }

    /**
     * 获取计算机存储单位
     * @param bytes
     */
    static getMemoryNumber(bytes: number): string {
        const K = 1 * 1024;
        const M = K * 1024;
        const G = M * 1024;
        const T = G * 1024;
        if (bytes < K) {
            return `${bytes}B`;
        }
        if (bytes < M) {
            return `${Math.floor(bytes / K).toFixed(2)}K`;
        }
        if (bytes < G) {
            return `${Math.floor(bytes / M).toFixed(2)}M`;
        }
        if (bytes < T) {
            return `${Math.floor(bytes / G).toFixed(2)}G`;
        }
        return `${Math.floor(bytes / T).toFixed(2)}T`;
    }




    /**
     * A*寻路
     * @param map 地图二维数组
     * @param startPot 寻路起始点
     * @param endPot 寻路终点
     * @param openList 开合队列 默认传startPot
     * @param closeList 闭合队列
     * @param findNextPos 下个节点可走路径迭代数组
     * @param trafficConditions 可行走规则
     * @param outPathPots  out参数 最终路径
     * @return 最终路径
     */
    static aStarPathFind<T>(
        map: T[][],
        startPot: AStarPot,
        endPot: AStarPot,
        openList: AStarPot[],
        closeList: CloseAStarPotMap,
        findNextPos: AStarPot[],
        trafficConditions: (currFind: T) => boolean,
        outPathPots: AStarPot[]): AStarPot[] {
        /*
         *   调用示例
            const list: AStarPot[] = [];
            const openList = [new AStarPot(0, 0, null)];
            const startPot = new AStarPot(0, 0, null);
            const endPot = new AStarPot(this.cellSize - 1, this.cellSize - 1, null);
            const findPots = [
                new AStarPot(0, 1, null),
                new AStarPot(0, -1, null),
                new AStarPot(1, 0, null),
                new AStarPot(-1, 0, null),
            ];
            data_control.aStarPathFind(
                this.m_desk,
                startPot,
                endPot,
                openList,
                {},
                findPots,
                currFind => {
                    return currFind.type != PotType.STOP;
                },
                list
            );
        */
        //找到open队列里 gh距离最近的点
        if (openList.length > 0) {
            let fi = 0;
            let minDistance = null;
            for (let i = 0; i < openList.length; i++) {
                const currI = openList[i];
                // let distanceI = Math.sqrt(
                //     //Math.abs(currI.i - startPot.i)
                //     //Math.abs(currI.parentCount)
                //     Math.pow(Math.abs(currI.parentCount), 2) + Math.pow(Math.abs(currI.j - startPot.j), 2)
                // );
                let distanceS = Math.sqrt(
                    Math.pow(Math.abs(currI.i - startPot.i), 2) + Math.pow(Math.abs(currI.j - startPot.j), 2)
                );
                let distanceE = Math.sqrt(
                    Math.pow(Math.abs(currI.i - endPot.i), 2) + Math.pow(Math.abs(currI.j - endPot.j), 2)
                );
                let distanceI = distanceS + distanceE;
                if (minDistance == null || distanceI < minDistance) {
                    fi = i;
                    minDistance = distanceI;
                }
            }
            let fPotUnit = openList[fi];
            // O1HD.emit('drawOne', fPotUnit, cc.Color.GRAY);
            //到达目标点
            if (fPotUnit.i == endPot.i && fPotUnit.j == endPot.j) {
                //
                outPathPots.length = 0;
                let p = fPotUnit;
                //反向找出路径
                while (p) {
                    outPathPots.push(p);
                    p = p.parent;
                }
                //倒序即为路径
                outPathPots.reverse();
            } else {
                closeList[`${fPotUnit.i}-${fPotUnit.j}`] = true;
                // closeList.push(fPotUnit);
                openList.splice(fi, 1);
                //方向
                for (let dir of findNextPos) {
                    let cuDir = new AStarPot(fPotUnit.i + dir.i, fPotUnit.j + dir.j, fPotUnit);
                    //边界外 不加
                    if (cuDir.i >= map.length || cuDir.i < 0 || cuDir.j >= map[0].length || cuDir.j < 0) continue;
                    //不满足条件格子 不加
                    if (!trafficConditions(map[cuDir.i][cuDir.j])) continue;
                    //已经在关闭队列 不加
                    if (closeList[`${cuDir.i}-${cuDir.j}`]) continue;
                    //不在打开队列 加入
                    if (!cuDir.inList(openList)) {
                        openList.push(cuDir);
                    }
                }
                //打开队列有点
                if (openList.length > 0) {
                    this.aStarPathFind(map, startPot, endPot, openList, closeList, findNextPos, trafficConditions, outPathPots);
                }
            }
        } else {
            console.log('没有到达目标终点');
            // outPathPots.length = 0;
        }
        return outPathPots;
    }

    /**
     * 获取 展示的 金币数
     */
    static getShowCoins( coins : number , coinType : number ) : string {
        let unit = NUMBER_NEW_FORMATS[coinType];
        return `${coins}${coinType == 0 ? "" : unit.text}`;
    }

    /**
     * 获取实际秒数
     * @param hour
     * @param minute
     */
    static getSeconds( hour : number , minute : number ) : number {
        return hour * 10 + Math.floor( minute / gameConfig.CHICKEN_SECONDS_RATE ) * 1;
    }

    static getWriteCoins(coins:number){
        const ary = NUMBER_NEW_FORMATS;
        let num:number = null;
        let formats:number = null;
        for (let i = ary.length - 1; i > 0; i--) {
            const {numValue, text} = ary[i];
            if (coins >= numValue) {
                num = Number((coins / numValue).toFixed(0));
                formats = i;
                break;
            }
        }
        if(num == null && formats == null){
            num = Number(Number(coins).toFixed(0)) || 0;
            formats = 0;
        }
        return {num:num,formats:formats};
    }

        /**
     * 输入两个向量，计算第一个相对于第二个的夹角∠
     * @param targetVec 目标向量
     * @param originVec 基准向量,默认为（0，1）
     */
    public static GetAngle(targetVec:cc.Vec2,originVec:cc.Vec2 = cc.v2(0,1)):number{
        let nor = targetVec.normalize();
        let nor2 = originVec.normalize();
        
        let acos : number = nor.dot(nor2);
        let cross = nor.cross(nor2);//this.PointCross(nor,nor2) ;//
        let angle:number = Math.acos(acos);

        if(cross == 0){
            cross = acos<0?1:0;
        }
        
        angle*=Math.sign(cross);
        
        angle *= 180/Math.PI;
        // console.log(`nor:${nor.x},${nor.y}\nnor2:${nor2.x},${nor2.y}\nacos:${acos}\ncross:${cross}\nangle:${angle}`);
        // angle = Math.round(angle);
        if(isNaN(angle)){
            angle = acos < 0 ? 180 : 0;
        }

        return angle;

    }
}

/**
 * class 数据控制集
 *
 * */
const NUMBER_NEW_FORMATS = [
    {numValue: 1e4, text: '万'},
    {numValue: 1e8, text: '亿'},
    {numValue: 1e12, text: '兆'},
    {numValue: 1e16, text: '蛇'},
    {numValue: 1e20, text: '马'},
    {numValue: 1e24, text: '羊'},
    {numValue: 1e28, text: '猴'},
    {numValue: 1e32, text: '鸡'},
    {numValue: 1e36, text: '狗'},
    {numValue: 1e40, text: '猪'},
    {numValue: 1e44, text: '鼠'},
    {numValue: 1e48, text: '牛'},
    {numValue: 1e52, text: '虎'},
    {numValue: 1e56, text: '兔'},
    {numValue: 1e60, text: '龙'},
    {numValue: 1e64, text: '玄武'},
    {numValue: 1e68, text: '朱雀'},
    {numValue: 1e72, text: '白虎'},
    {numValue: 1e76, text: '青龙'},
    {numValue: 1e80, text: '太阴'},
    {numValue: 1e84, text: '太阳'},
    {numValue: 1e88, text: '饕餮'},
    {numValue: 1e92, text: '混沌'},
    {numValue: 1e96, text: '穷奇'},
    {numValue: 1e100, text: '梼杌'},
    {numValue: 1e104, text: 'tt'},
    {numValue: 1e108, text: 'uu'},
    {numValue: 1e112, text: 'vv'}
];
